import { Link } from "gatsby"
import { btn, btnPrimary } from "../ds/button.module.css"
import { WhiteArrowRight } from "../ds/Shapes"
import { CheckIconGreen } from "../ds/SvgIcons"
import { StaticImage } from "gatsby-plugin-image"
import Header from "../components/Header"
import Layout from "../components/Layout"
import HowItWorks from "../components/ai-distribution/HowItWorks"
import CustomizableLandingPage from "../components/ai-distribution/CustomizableLandingPage"
import IntegrationGuideStripe from "../components/integrations/IntegrationGuideStripe"
import PremagicNewsSection from "../components/PremagicNews"
import FaqAccordion from "../components/FaqAccordion"

export default function index() {
  return (
    <Layout
      title="AI Photo Distribution for Events: Instant, Face-Matched Delivery"
      description="AI photo distribution that delivers every attendee their event photos automatically via WhatsApp & email using face recognition. Faster sharing, more reach, more registrations."
      keywords={[
        "AI photo distribution, WhatsApp photo delivery, face recognition events, instant photo sharing, automated photo delivery, event photo recognition, smart photo distribution, attendee photo matching, AI-powered photo sharing, event photography automation, facial recognition photo delivery, real-time photo sharing, personalized photo delivery, secure photo distribution, AI photo technology",
      ]}
      breadcrumbs={[
        { name: "Home", url: "/" },
        {
          name: "Photo Distribution",
          url: "/smart-photo-distribution-for-seamless-events/",
        },
      ]}
    >
      <div className="">
        <div className="" style={{ backgroundColor: "#7251F4" }}>
          <Header isWhiteLogo />
        </div>

        <section className="py-28" style={{ backgroundColor: "#7251F4" }}>
          <div className="px-5 md:px-0 mx-auto md:w-[1080px]">
            <div className="md:flex items-center h-[550px] md:h-[500px]">
              <div className="md:w-5/12 flex flex-col justify-center text-left">
                <h1 className="text-3xl md:text-5xl font-bold mb-4 text-white">
                  AI Photo Distribution:
                  <span style={{ color: "#61F2C2" }}>
                    {" "}
                    Get Event Photos to Every Attendee, Instantly
                  </span>
                </h1>
                <p className="text-white mb-5">
                  Deliver
                  <span style={{ color: "#61F2C2" }}>
                    {" "}
                    AI-powered photo galleries
                  </span>{" "}
                  straight to your attendee's inbox!{" "}
                </p>
                <Link
                  to="/request-a-demo/"
                  className={`${btn} ${btnPrimary} text-xs mt-5 mb-10 md:mb-0 relative w-max group`}
                >
                  <span className="mr-4 ml-2">Show me how</span>
                  <WhiteArrowRight className="transition duration-300 ease-in-out group-hover:translate-x-2 mr-2" />
                </Link>
              </div>
              <div className="w-5/6 md:w-7/12 md:ml-0 relative">
                <div className="">
                  <StaticImage
                    src="../images/ai-distribution_hero.png"
                    alt="smart-photo-distribution-events-hero"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="md:pt-10">
          <div className="px-5 md:px-0 mx-auto md:w-[1080px]">
            <div className="flex flex-col md:flex-row flex-col-reverse py-10">
              <div className="md:w-5/12 flex flex-col justify-center text-left md:pr-10 md:mt-0">
                <h2
                  className="text-3xl md:text-4xl font-bold md:leading-snug mb-4"
                  style={{ color: "#7251F4" }}
                >
                  How does AI photo <br />
                  distribution work at events?
                </h2>
                <p>
                  Premagic's AI photo distribution automatically delivers the
                  right event photos to the right person. Our face-recognition
                  engine matches each attendee to their photos and sends them
                  over WhatsApp and email within minutes — turning every shared
                  photo into organic reach for your event.
                </p>
                <Link
                  to="/request-a-demo/"
                  className={`${btn} ${btnPrimary} text-xs mt-10 mb-10 md:mb-0 relative w-max group`}
                >
                  <span className="mr-4 ml-2">Show me how</span>
                  <WhiteArrowRight className="transition duration-300 ease-in-out group-hover:translate-x-2 mr-2" />
                </Link>
              </div>
              <div className="md:w-7/12 md:pl-10 text-right mt-10 md:mt-0 -mr-10 md:mr-0">
                <StaticImage
                  src="../images/ai_dist_how_it_works.png"
                  alt="smart-photo-distribution-events-how-works"
                />
              </div>
            </div>
          </div>
        </section>

        <div className="hidden md:block">
          <HowItWorks />
        </div>
        <CustomizableLandingPage />

        <section className="my-20 mt-40">
          <div className="px-5 md:px-0 mx-auto flex py-10 md:items-center flex-wrap md:w-[1080px]">
            <div className="w-1/2 mb-20 md:mb-0 md:w-1/4 text-center">
              <StaticImage
                class="w-20 md:w-18"
                src="../images/ai_dist_metric_1.png"
                alt="smart-photo-distribution-events-metric"
              />
              <h4
                style={{ color: "#FF6550" }}
                className="text-4xl font-bold my-5"
              >
                99.9%
              </h4>
              <p>
                facial recognition <br />
                accuracy
              </p>
            </div>
            <div className="w-1/2 mb-20 md:mb-0 md:w-1/4 text-center">
              <StaticImage
                class="w-20 md:w-20"
                src="../images/ai_dist_metric_2.png"
                alt="smart-photo-distribution-events-metric"
              />
              <h4
                style={{ color: "#FF6550" }}
                className="text-4xl font-bold my-8 md:my-5 "
              >
                700K
              </h4>
              <p>
                events
                <br />
                powered
              </p>
            </div>
            <div className="w-1/2 md:w-1/4 text-center">
              <StaticImage
                class="w-20 md:w-20"
                src="../images/ai_dist_metric_3.png"
                alt="smart-photo-distribution-events-metric"
              />
              <h4
                style={{ color: "#FF6550" }}
                className="text-4xl font-bold my-5"
              >
                70%
              </h4>
              <p>
                increase in attendee
                <br />
                engagement
              </p>
            </div>
            <div className="w-1/2 md:w-1/4 text-center">
              <StaticImage
                class="w-20 md:w-20"
                src="../images/ai_dist_metric_4.png"
                alt="smart-photo-distribution-events-mtric"
              />
              <h4
                style={{ color: "#FF6550" }}
                className="text-4xl font-bold my-2 md:my-5"
              >
                60%
              </h4>
              <p>
                increase in <br />
                UGC
              </p>
            </div>
          </div>
        </section>

        <section
          className="py-20 md:py-0"
          style={{ backgroundColor: "#7251F4" }}
        >
          <div className="px-5 md:px-0 mx-auto md:flex py-20 items-center md:w-[1080px]">
            <div className="md:w-1/2 flex flex-col justify-center relative mb-20 md:mb-0">
              <div className="md:absolute">
                <StaticImage
                  width={350}
                  src="../images/etech_event.png"
                  alt="smart-photo-distribution-events-etech"
                />
              </div>
            </div>
            <div className="md:w-1/2">
              <h4 className="text-white text-center text-2xl">
                <span style={{ color: "#61F2C2" }}>“</span>Premagic really came
                through with solutions that not only saved us substantial time
                and effort but also felt like having an extra member on our
                team. We will definitely be using it for our future events.!
                <span style={{ color: "#61F2C2" }}>”</span>
              </h4>
              <h5
                className="text-2xl text-center mt-10"
                style={{ color: "#61F2C2" }}
              >
                Malavika Velayanikal
              </h5>
              <p className="text-white text-xl text-center">
                Director of Initiatives & Events SaaSBOOMi
              </p>
            </div>
          </div>
        </section>

        <section className="my-20 mt-40">
          <h4
            className="text-center text-3xl md:text-5xl mb-10"
            style={{ color: "#7251F4" }}
          >
            One Platform, Countless <br /> Industries, <b>10x Result</b>
          </h4>
          <div className="px-5 md:px-0 mx-auto flex py-10 md:items-center flex-wrap md:w-[1080px]">
            <div className="w-1/3 mb-20 md:mb-0 md:w-1/6 text-center">
              <StaticImage
                class="w-16 mt-10 md:w-18"
                src="../images/ai-dist-icons/1.png"
                alt="smart-photo-distribution-events-technology"
              />
              <p className="mt-5" style={{ color: "#7251F4" }}>
                Technology
              </p>
            </div>
            <div className="w-1/3 mb-20 md:mb-0 md:w-1/6 text-center">
              <StaticImage
                class="w-16 mt-10 md:w-18"
                src="../images/ai-dist-icons/2.png"
                alt="smart-photo-distribution-events-corporate"
              />
              <p className="mt-5" style={{ color: "#7251F4" }}>
                Corporate
              </p>
            </div>
            <div className="w-1/3 mb-20 md:mb-0 md:w-1/6 text-center">
              <StaticImage
                class="w-16 mt-10 md:w-18"
                src="../images/ai-dist-icons/3.png"
                alt="smart-photo-distribution-events-fine-tech"
              />
              <p className="mt-5" style={{ color: "#7251F4" }}>
                Fintech
              </p>
            </div>
            <div className="w-1/3 mb-20 md:mb-0 md:w-1/6 text-center">
              <StaticImage
                class="w-16 mt-10 md:w-18"
                src="../images/ai-dist-icons/4.png"
                alt="smart-photo-distribution-events-pharma"
              />
              <p className="mt-5" style={{ color: "#7251F4" }}>
                Pharma
              </p>
            </div>
            <div className="w-1/3 mb-20 md:mb-0 md:w-1/6 text-center">
              <StaticImage
                class="w-16 mt-10 md:w-18"
                src="../images/ai-dist-icons/5.png"
                alt="smart-photo-distribution-events-education"
              />
              <p className="mt-5" style={{ color: "#7251F4" }}>
                Education
              </p>
            </div>
            <div className="w-1/3 mb-20 md:mb-0 md:w-1/6 text-center">
              <StaticImage
                class="w-16 mt-10 md:w-18"
                src="../images/ai-dist-icons/6.png"
                alt="smart-photo-distribution-events-entertainment"
              />
              <p className="mt-5" style={{ color: "#7251F4" }}>
                Entertainment
              </p>
            </div>
            <div className="w-1/3 mb-20 md:mb-0 md:w-1/6 text-center">
              <StaticImage
                class="w-16 mt-10 md:w-18"
                src="../images/ai-dist-icons/7.png"
                alt="smart-photo-distribution-events-travel"
              />
              <p className="mt-5" style={{ color: "#7251F4" }}>
                Offset Corporate travel
              </p>
            </div>
            <div className="w-1/3 mb-20 md:mb-0 md:w-1/6 text-center">
              <StaticImage
                class="w-16 mt-10 md:w-18"
                src="../images/ai-dist-icons/8.png"
                alt="smart-photo-distribution-events-sports"
              />
              <p className="mt-5" style={{ color: "#7251F4" }}>
                Sports
              </p>
            </div>
            <div className="w-1/3 mb-20 md:mb-0 md:w-1/6 text-center">
              <StaticImage
                class="w-16 mt-10 md:w-18"
                src="../images/ai-dist-icons/9.png"
                alt="smart-photo-distribution-events-fetivals"
              />
              <p className="mt-5" style={{ color: "#7251F4" }}>
                Festivals
              </p>
            </div>
            <div className="w-1/3 mb-20 md:mb-0 md:w-1/6 text-center">
              <StaticImage
                class="w-16 mt-10 md:w-18"
                src="../images/ai-dist-icons/10.png"
                alt="smart-photo-distribution-events-expo"
              />
              <p className="mt-5" style={{ color: "#7251F4" }}>
                Expo
              </p>
            </div>
            <div className="w-1/3 mb-20 md:mb-0 md:w-1/6 text-center">
              <StaticImage
                class="w-16 mt-10 md:w-18"
                src="../images/ai-dist-icons/11.png"
                alt="smart-photo-distribution-events-conference"
              />
              <p className="mt-5" style={{ color: "#7251F4" }}>
                Conferences
              </p>
            </div>
            <div className="w-1/3 mb-20 md:mb-0 md:w-1/6 text-center">
              <StaticImage
                class="w-16 mt-10 md:w-18"
                src="../images/ai-dist-icons/12.png"
                alt="smart-photo-distribution-events-wedding"
              />
              <p className="mt-5" style={{ color: "#7251F4" }}>
                Weddings
              </p>
            </div>
          </div>
        </section>

        {/* <RequestDemo /> */}

        {/* Add-ons */}
        <section className="py-16 bg-gray-50">
          <div className="px-5 md:px-0 mx-auto md:w-[1080px]">
            <div className="text-center mb-10">
              <p
                className="text-sm font-semibold tracking-widest uppercase mb-3"
                style={{ color: "#7251F4" }}
              >
                Add-ons
              </p>
              <h2 className="text-2xl md:text-3xl font-bold text-black">
                Extend Photo Distribution with these add-ons
              </h2>
              <p className="text-sm text-gray-600 mt-3 max-w-2xl mx-auto">
                Pair Photo Distribution with these optional capabilities to
                unlock richer attendee journeys and sponsor value.
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <Link
                to="/simplify-event-registration/"
                className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow border border-gray-100 group"
              >
                <h3 className="font-bold text-lg text-black mb-2">
                  Registration with Face Check-In
                </h3>
                <p className="text-sm text-gray-600">
                  Streamline attendee registration and on-site check-in with
                  face recognition.
                </p>
                <span
                  className="inline-flex items-center text-sm font-semibold mt-4 transition-transform duration-200 group-hover:translate-x-1"
                  style={{ color: "#7251F4" }}
                >
                  Learn more →
                </span>
              </Link>
              <Link
                to="/event-networking-app/"
                className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow border border-gray-100 group"
              >
                <h3 className="font-bold text-lg text-black mb-2">
                  Ripple: Smart Event Networking
                </h3>
                <p className="text-sm text-gray-600">
                  Help attendees discover and connect with the right people
                  throughout your event.
                </p>
                <span
                  className="inline-flex items-center text-sm font-semibold mt-4 transition-transform duration-200 group-hover:translate-x-1"
                  style={{ color: "#7251F4" }}
                >
                  Learn more →
                </span>
              </Link>
              <Link
                to="/sponsored-content/"
                className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow border border-gray-100 group"
              >
                <h3 className="font-bold text-lg text-black mb-2">
                  Sponsor Content
                </h3>
                <p className="text-sm text-gray-600">
                  Turn every attendee share into sponsor exposure with branded
                  content placements.
                </p>
                <span
                  className="inline-flex items-center text-sm font-semibold mt-4 transition-transform duration-200 group-hover:translate-x-1"
                  style={{ color: "#7251F4" }}
                >
                  Learn more →
                </span>
              </Link>
            </div>
          </div>
        </section>
        <FaqAccordion
          faqs={[
            {
              question: "What is AI photo distribution?",
              answer:
                "It's the automatic delivery of event photos to attendees using AI face recognition, so each person receives only their own photos without manual sorting.",
            },
            {
              question: "How does face-recognition photo sharing work?",
              answer:
                "Photographers upload photos; the AI detects faces, matches them to registered attendees, and delivers personalized galleries instantly.",
            },
            {
              question: "How does photo distribution help event marketing?",
              answer:
                "When attendees receive branded, share-ready photos, they post them — extending your event's organic reach and driving registrations for next time.",
            },
          ]}
        />
        <PremagicNewsSection />
        <IntegrationGuideStripe context="Already using Cvent, HubSpot, Swapcard or Luma? Photos flow into your attendees' tickets automatically." />
      </div>
    </Layout>
  )
}
